// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".acitve-tab-custom-form {\n  border-color: #16cd8e #16cd8e #fff !important;\n}", ""]);
// Exports
module.exports = exports;
